(ns frontend.test.lp-portal.modals.chart-editor.view
  (:require
   [frontend.test.lp-portal.modals.chart-editor.event :as event]
   [frontend.test.lp-portal.modals.chart-editor.style :as style]
   [frontend.test.lp-portal.modals.chart-editor.sub :as sub]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [herb.core :as h]
   [re-frame.core :as rf]
   [ui.components.text.view :as text]))


#_(defn resolve-series-data
    [local-state label]
    (->> @local-state
         :manual-data
         :data
         (filter (fn [row-data]
                   (= (first row-data) label)))
         (map (fn [row-data]
                (rest row-data)))
         (first)))

(defn view
  []
  (rf/dispatch-sync [::sub/init])
  (fn []
    (let [manual-data-set @(rf/subscribe [::sub/manual-data-set])
          imported-data-set @(rf/subscribe [::sub/imported-data-set])
          previous-data-set-published-on @(rf/subscribe [::sub/previous-data-set-published-on])
          previous-data-set-reference-date @(rf/subscribe [::sub/previous-data-set-reference-date])
          selected-data-config @(rf/subscribe [::sub/selected-data-config])
          selected-data-set @(rf/subscribe [::sub/selected-data-set])
          previous-data-set @(rf/subscribe [::sub/previous-data-set])
          manual-data-set-label @(rf/subscribe [::sub/manual-data-set-label])
          imported-data-set-label @(rf/subscribe [::sub/imported-data-set-label])
          previous-data-set-label @(rf/subscribe [::sub/previous-data-set-label])
          chart-edit? true
          chart-select? true]
      [:div
       {:class (h/join "bg-base-light text-base-light-text")}
       [text/h1 {} "Chart editor"]
       [:div
        {:class (h/<class style/chart-container)}
        [chart-view/chart
         ;; CONFIG
         (merge selected-data-config
                {:manual-data-set                  manual-data-set
                 :imported-data-set                imported-data-set
                 :previous-data-set                previous-data-set
                 :manual-data-set-label            manual-data-set-label
                 :imported-data-set-label          imported-data-set-label
                 :previous-data-set-label          previous-data-set-label
                 :previous-data-set-published-on   previous-data-set-published-on
                 :previous-data-set-reference-date previous-data-set-reference-date
                 :selected-data-set                selected-data-set
                 :selected-data-set-path           [:financials :selected-data-set]
                 :manual-data-set-path             [:financials :manual-data]
                 :chart-config->editable-data      financials-controller/config->editable-data
                 :editable-data->raw-data          financials-controller/editable-data->raw-data})
         ;; PROPS
         {:edit-mode?    true
          :save-text     (fn [path data]
                           (rf/dispatch [::event/save-dynamic-data path data]))
          :chart-edit?   chart-edit?
          :chart-select? chart-select?}]]

       #_[edit-chart-modal/view
          {:hide!    #(swap! local-state assoc :visible? false)
           :visible? (:visible? @local-state)
           :data     (:manual-data @local-state)
           :save!    #(swap! local-state assoc
                             :manual-data %
                             :visible? false)}]])))
